import {AxiosInstance} from "axios";
import Account from "../model/account/Account";

/**
 * Account Api.
 */
export default class AccountApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch accounts for partner brand.
	 * @returns {Promise<Account[]>} Promise containing all accounts for partner brand.
	 */
	fetchAccounts(partnerBrandId: string): Promise<Account[]> {
		const url = `/api/web/accounting/partner_brands/${partnerBrandId}/accounts`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(Account.fromJson));
	}
}
